module.exports = {"HAS_COUPON":true,"MAX_QUANTITY_OPTION":50}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/theme/basket.json
// module id = 549
// module chunks = 1